/**
 * @desc 详情
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.stockAdjustmentMaster.getDetailByAdno.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/stockAdjustmentMaster/getDetail`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
